<script>
import Card from "@/pages/components/card.vue";
import TablePlugin from "@wielink/datatables";
import DefaultRenderers from "@wielink/datatables/Renderers/DefaultRenderers";
import Datatable from "@wielink-application/shared/js/mixins/datatable";
import EditModal from '@wielink/datatables/Plugins/EditModal';
import AssetableModal from "@/pages/components/assets/AssetableModal.vue";
import AssetableActionRenderer from "@/pages/components/assets/AssetableTable/AssetableActionRenderer";
import DefaultPlugins from "@wielink/datatables/Plugins/DefaultPlugins";

export default {
	mixins: [Datatable],
	components: {AssetableModal, Card},
	props: {
		id: {
			type: String,
			required: true,
		},
		title: {
			type: String,
			required: true,
		},
		assetableGroup: {
			type: String,
			required: true,
		},
		assetableType: {
			type: String,
			required: true,
		},
		assetableId: {
			type: Number,
			required: true,
		},
	},
	mounted() {
		this.$refs.assetableModal.setTable(this.$refs.table);
	},
	methods: {
		initialiseDatatable() {
			new TablePlugin({
				scope: this.$refs.table.$refs.table,
				renderers: {...DefaultRenderers, actions: AssetableActionRenderer},
				plugins: {EditModal,...DefaultPlugins}
			});
		},
		newAsset() {
			this.$refs.assetableModal.newAsset();
		}
	}
}
</script>

<template>
	<Card>
		<div class="d-flex flex-row flex-wrap gap-3 mb-3 align-items-center justify-content-between">
			<h2 class="card-title m-0">{{ this.title }}</h2>
			<div class="d-flex flex-row flex-wrap column-gap-3 row-gap-2">
				<button @click.prevent="this.newAsset()" class="btn btn-primary">
					<i class="bi bi-plus-lg"></i>
					Nieuw
				</button>
			</div>
		</div>
		<Table ref="table" groupClasses="table-compact" :config="tableConfig"/>

		<AssetableModal :id="this.id + '_modal'" :assetable-id="this.assetableId" :assetable-group="this.assetableGroup" :assetable-type="this.assetableType" ref="assetableModal"/>
	</Card>
</template>
